import { memo } from 'react';

import { AvatarComponent } from '@/components/ui/avatar/avatar';

interface Props {
  name: string;
  avatar?: string | null;
}

export const WorkflowGroup = memo(({ name, avatar }: Props) => (
  <div
    className="flex flex-none flex-row items-center"
    data-cy={`workflow-group-${name}`}
    data-testid="workflow-group"
  >
    {avatar && (
      <div className="mr-2 shrink-0" data-testid="workflow-group-avatar">
        <AvatarComponent name={name} size={22} source={avatar} />
      </div>
    )}
    {name}
  </div>
));
